import {combineReducers} from 'redux';
import {firebaseReducer} from 'react-redux-firebase';
import {firestoreReducer} from 'redux-firestore';
import authReducer from './authReducer';
import localReducer from './localReducer';
import utilityReducer from './utilityReducer';

export default combineReducers({
  auth: authReducer,
  local: localReducer,
  utility: utilityReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
